export default {
    ALREADY_EXISTS: 'Eine Gilde mit diesem Namen existiert bereits.',
    ALREADY_IN_GUILD: 'Du bist bereits in einer Gilde.',
    CANNOT_KICK_YOURSELF: 'Du kannst dich nicht selbst aus der Gilde entfernen.',
    GUILD_FULL: 'Diese Gilde ist voll.',
    MUST_FINISH_TUTORIAL_CREATE:
        'Du musst das Tutorial beenden, bevor du eine Gilde gründen kannst.',
    NO_PERMISSION: 'Du hast keine Erlaubnis, das zu tun.',
    NO_PERMISSION_RANK: 'Du hast nicht die Erlaubnis, den Rang dieses Mitglieds zu ändern.',
    NOT_ENOUGH_GOLD: 'Du brauchst 30.000 Gold in deinem Inventar, um eine Gilde zu gründen.',
    NOT_ALLOWED_GUESTS_JOIN: 'Gäste dürfen Gilden nicht beitreten.',
    NOT_ALLOWED_GUESTS_CREATE: 'Gäste dürfen keine Gilden gründen.'
} as const;
